import { DateTime } from '@ksyos/date-time';

export function NullableFormattedDatetime(props: { value?: Date | string | null }) {
    if (props.value) {
        const dateTime = DateTime.from(props.value);

        return <>{`${dateTime.format('l')} ${dateTime.format('LT')}`}</>;
    } else {
        return null;
    }
}
